import { useConfiguration } from '~/context/common/StaticContext';
import {
  useGetTradeInStatus,
  useIsTradeInApplied
} from '~/context/common/TradeContext';
import useGetIsInTaxSavingRestrictedState from './useGetIsInTaxSavingRestrictedState';

type OwnArgs = {
  tradeIncentive?: number;
  tradeTaxSavings?: number;
};

// there is currently a bug where if you select a pending trade-in we still show the /w trade treatment
// added isActive here to hide in this scenario but we should revisit once that bug is fixed
export default function useShowTradeIncentivesCopy({
  tradeIncentive,
  tradeTaxSavings
}: OwnArgs = {}) {
  const { shouldShowWSYS = false } = useConfiguration();
  const isTradeInApplied = useIsTradeInApplied();
  const isInTaxRestrictedState = useGetIsInTaxSavingRestrictedState();
  const { isActive } = useGetTradeInStatus();

  const shouldShowTreatment = shouldShowWSYS && isTradeInApplied && isActive;

  const hasTaxSavings = (tradeTaxSavings ?? 0) > 0;
  const hasTradeIncentive = (tradeIncentive ?? 0) > 0;

  return {
    showTaxSavings:
      shouldShowTreatment && hasTaxSavings && !isInTaxRestrictedState,
    showTradeIncentive: shouldShowTreatment && hasTradeIncentive
  };
}
